import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { SitemapCustomService } from 'avn/modules/features/terms/sitemap/service/sitemap-custom.service';

@Component({
  selector: 'app-sitemap',
  templateUrl: './sitemap.html',
  styleUrls: ['./sitemap.scss'],
  imports: [RouterLink],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class SiteMapComponent implements OnInit {
  public readonly siteMapArray = signal<any[]>([]);

  public constructor(
    private readonly sitemapService: SitemapCustomService,
    private readonly cdr: ChangeDetectorRef
  ) {}

  public ngOnInit(): void {
    this.getAllServices();
  }

  public getAllServices(): void {
    this.sitemapService.getCategoryServices().subscribe((response) => {
      this.siteMapArray.set(response.data);
      this.cdr.markForCheck();
    });
  }

  public getRouterUrl(text: string, subText?: string): string {
    let txt = '/category';
    if (subText) {
      txt += '/' + subText.toLowerCase().replace(/ /g, '-');
    }
    return txt + '/' + text.toLowerCase().replace(/ /g, '-');
  }

  public checkSiteMapName(name: string): boolean {
    return name.indexOf('(') > -1 || name.indexOf(')') > -1;
  }
}
